import script from "./SelectClass.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectClass.vue?vue&type=script&setup=true&lang=ts"

import "./SelectClass.vue?vue&type=style&index=0&id=363f773a&lang=scss&scoped=true"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-363f773a"]])

export default __exports__